import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, IconButton, Menu, MenuItem } from "@mui/material";

import { GridColDef } from "@mui/x-data-grid";
import SearchBar from "../../components/SearchBar";
import TableComponent from "../../components/TableComponent";

const BranchEmployees = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");

  const rows = [
    {
      id: 1,
      visaType: "Tourist",
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      country: "Canada",
      nationality: "Indian",
      registeredBy: "Company",
    },
    {
      id: 2,
      visaType: "Study",
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      country: "Canada",
      nationality: "Indian",
      registeredBy: "Freelancer Agent",
    },
    {
      id: 3,
      visaType: "Work",
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      country: "Canada",
      nationality: "Indian",
      registeredBy: "Salaried Agent",
    },
    {
      id: 4,
      visaType: "Business",
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      country: "Canada",
      nationality: "Indian",
      registeredBy: "Self Registration",
    },
    {
      id: 5,
      visaType: "Business",
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      country: "Canada",
      nationality: "Indian",
      registeredBy: "Self Registration",
    },
  ];

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.03,
      minWidth: 80,
      field: "id",
      headerName: "S.No",
      editable: false,
      sortable: false,
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: "image",
      headerName: "Employee Details",
      editable: false,
      sortable: false,

      renderCell: () => {
        return (
          <div className="user_block">
            <figure
            // onClick={() => navigate("/profile-detail/individual")}
            >
              <img src="/static/images/user_attachment.jpg" alt="" />
            </figure>
            <p>
              <b>Emma Smith</b> +9203024595467 <br />
              emma@gmail.com
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 150,
      field: "department",
      headerName: "Department",
      editable: false,
      sortable: false,

      renderCell: () => {
        return (
          <div className="user_block">
            <p>Sales</p>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 150,
      field: "joiningDate",
      headerName: "Joining Date",
      editable: false,
      sortable: false,

      renderCell: () => {
        return (
          <div className="user_block">
            <p>11 Mar 2025</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "citizenShip",
      headerName: "Citizenship",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block">
            <p>Afganistan</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "resindence",
      headerName: "Country of Residence",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block">
            <p>UAE</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "createdAt",
      headerName: "Created At",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block">
            <p>11 Mar 2025</p>
          </div>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {/* <MenuItem onClick={() => navigate(`detail/${1}`)}>
                  View
                </MenuItem> */}
                <MenuItem onClick={() => navigate(`/edit-employee/${1}`)}>
                  Edit
                </MenuItem>
                <MenuItem onClick={handleClose1}>Delete</MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <div className="main_title">
        <h1>Employees</h1>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search"
                />
              </Box>
            </div>
            <div className="right_s fdx">
              <Button
                className="btn btn_blue"
                onClick={() => navigate("/add-employee")}
              >
                Add Employee
              </Button>
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent columns={columns} rows={rows} />
          </div>
        </Box>
      </div>
    </div>
  );
};

export default BranchEmployees;
